import { FC } from 'react';

import { IGiaItem } from 'api/types';
import { splittedDataToSortedArray } from 'containers/pdfStudent/utils';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetStudyGia } from 'icons/widgets';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getAcademicYearByDate, getDataLoadRequests, isDateValid } from 'utils';

import PdfCommonDataEntityContainer from '../../../containers/pdfStudent/dataEntityContainers/common';
import { studyTrialExamSelector } from '../../../selectors';
import AcademicYearTitle from '../AcademicYearTitle';
import ExamContainer from '../PdfGia/ExamContainer';

const splitTrialExamByAcademicYear = (data: IGiaItem[], academicYears: string[]) => {
  const learningYearData: Record<string, IGiaItem[]> = {};

  data.forEach((item) => {
    const date = new Date(item.date);

    if (!isDateValid(date)) {
      return;
    }

    const period = getAcademicYearByDate(date);
    if (academicYears.includes(period)) {
      if (learningYearData[period]) {
        learningYearData[period].push(item);
      } else {
        learningYearData[period] = [item];
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};

const PdfTrialExam: FC = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().studyGia });
  const trialEgeExams = useAppSelector(studyTrialExamSelector);

  const academicYearData = splitTrialExamByAcademicYear(trialEgeExams.content, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Пробный Единый государственный экзамен (ЕГЭ)" Icon={IconWidgetStudyGia}>
      {academicYearData.map(([academicYear, data]) => (
        <div key={academicYear}>
          <AcademicYearTitle academicYear={academicYear} />
          <ExamContainer exams={data} />
        </div>
      ))}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfTrialExam;
